import React from "react";
import { Badge } from "@mantine/core";

type Props = {
  similarityScore: number | null;
};

export const AdvancedCopyDevicesSimilarityBadge: React.FC<Props> = ({ similarityScore }) => {
  const color =
    similarityScore == null
      ? "gray"
      : similarityScore >= 0.85
        ? "green"
        : similarityScore >= 0.65
          ? "yellow"
          : "red";

  return (
    <Badge color={color} variant="light" size="lg">
      Likhet: {similarityScore == null ? "-" : `${Math.round(similarityScore * 100)} %`}
    </Badge>
  );
};
